const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(":host{display:block}:host([hidden]){display:none}");
export default styleSheet;